// OHLCV has no trade-at-price data. Distribute each candle's volume uniformly
// over its high-low span; never invent a histogram when data is unavailable.
export function volumeProfile(bars, start, end, low, high, rows=24) {
    rows=Math.max(2,Math.min(200,Math.floor(rows)||24));
    const bins=Array(rows).fill(0);
    if(!Number.isFinite(low)||!Number.isFinite(high)||high<=low) return bins;
    const step=(high-low)/rows;
    for(const bar of bars || []) {
        const [time,,barHigh,barLow,,volume]=bar;
        if(time<Math.min(start,end)||time>Math.max(start,end)||!Number.isFinite(volume)||volume<=0||!Number.isFinite(barHigh)||!Number.isFinite(barLow)||barHigh<barLow)continue;
        if(barHigh===barLow){
            if(barLow>=low&&barLow<=high)bins[Math.min(rows-1,Math.floor((barLow-low)/step))]+=volume;
            continue;
        }
        for(let i=0;i<rows;i++){
            const overlap=Math.max(0,Math.min(barHigh,low+(i+1)*step)-Math.max(barLow,low+i*step));
            bins[i]+=volume*overlap/(barHigh-barLow);
        }
    }
    return bins;
}

// Directional volume from candle direction is not bid/ask or aggressor volume.
export function volumeProfileDetails(bars,start,end,low,high,rows=24,valueAreaPercent=70){
 const total=volumeProfile(bars,start,end,low,high,rows);
 const up=volumeProfile((bars || []).filter(c=>c[4]>=c[1]),start,end,low,high,rows);
 const down=total.map((v,i)=>Math.max(0,v-up[i]));
 const sum=total.reduce((s,v)=>s+v,0),peak=Math.max(...total),poc=total.indexOf(peak),target=sum*Math.min(100,Math.max(0,valueAreaPercent))/100;
 let lower=poc,upper=poc,included=total[poc] || 0;
 while(included<target && (lower>0||upper<total.length-1)){
  const above=upper+1,below=lower-1,av=above<total.length?total[above]:-1,bv=below>=0?total[below]:-1;
  const chooseAbove=av>bv || av===bv&&(above-poc<=poc-below),next=chooseAbove?above:below,volume=total[next];
  if(included+volume>target)break;
  included+=volume;if(chooseAbove)upper=next;else lower=next;
 }
 const step=(high-low)/total.length;
 return {total,up,down,delta:up.map((v,i)=>v-down[i]),sum,poc,pocPrice:low+(poc+.5)*step,val:low+lower*step,vah:low+(upper+1)*step,lower,upper,valueAreaVolume:included};
}
